import React, { useState, useEffect, createContext } from "react"
import { useDispatch } from "react-redux"
import PropTypes from "prop-types"
import { triggerAction } from "../store/constants"
import { processOfflineQueue, resetQueue } from "../store/api/queue"
import { checkOnlineStatus } from "../view/shared/utilities/cache"

export const NetworkStatusContext = createContext()


export const NetworkStatusProvider = ({ children }) => {
  const dispatch = useDispatch()
  const [isOnline, setIsOnline] = useState(navigator.onLine)

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true)
      dispatch(triggerAction("UPDATE_NETWORK_STATUS", true))
      processOfflineQueue()
    }

    const handleOffline = () => {
      setIsOnline(false)
      dispatch(triggerAction("UPDATE_NETWORK_STATUS", false))
    }

    const intervalId = setInterval(async () => {
      const online = await checkOnlineStatus()
      if (online !== isOnline) {
        if (online) {
          handleOnline()
        } else {
          handleOffline()
        }
      }
    }, 5000) // Check every 5 seconds

    window.addEventListener("online", handleOnline)
    window.addEventListener("offline", handleOffline)

    // Set the initial status in Redux as well
    dispatch(triggerAction("UPDATE_NETWORK_STATUS", navigator.onLine))

    return () => {
      clearInterval(intervalId)
      window.removeEventListener("online", handleOnline)
      window.removeEventListener("offline", handleOffline)
    }
  }, [dispatch, isOnline])

  return (
    <NetworkStatusContext.Provider value={{ isOnline }}>
      {children}
    </NetworkStatusContext.Provider>
  )
}

NetworkStatusProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
